
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dynamic",
      function () {
        return require("private-next-pages/dynamic.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dynamic"])
      });
    }
  